import { type FC } from 'react';

import { Box } from '../Box';
import { Text } from '../Typography';
import {
  cardStyles,
  checkIndicatorStyles,
  radioStyles,
} from './SelectableOptionCard.styles';
import { type SelectableOptionCardProps } from './SelectableOptionCard.types';

const SelectableOptionCard: FC<SelectableOptionCardProps> = ({
  title,
  subtitle,
  footer,
  selected = false,
  disabled = false,
  variant = 'default',
  tone = 'default',
  className,
  type = 'button',
  ...rest
}) => {
  // Included (non-interactive) plus perks use a checkmark; selectable cards use radio.
  const showPlusCheckmark = variant === 'plus' && disabled;

  return (
    <button
      type={type}
      css={cardStyles(selected, disabled, variant, tone)}
      className={className}
      disabled={disabled}
      aria-pressed={selected}
      {...rest}
    >
      <Box display="flex" alignItems="flex-start" gap="var(--spacing-3)">
        {showPlusCheckmark ? (
          <span aria-hidden="true" css={checkIndicatorStyles}>
            ✓
          </span>
        ) : (
          <span aria-hidden="true" css={radioStyles(selected)} />
        )}

        <Box
          display="flex"
          flexDirection="column"
          gap="var(--spacing-1)"
          flex={1}
          minWidth={0}
        >
          <Text as="span" size="md" fontWeight="bold">
            {title}
          </Text>

          {subtitle ? (
            <Text as="span" size="sm" color="var(--text-secondary)">
              {subtitle}
            </Text>
          ) : null}

          {footer ? (
            <Box
              display="flex"
              flexWrap="wrap"
              gap="var(--spacing-2)"
              mt="var(--spacing-2)"
            >
              {footer}
            </Box>
          ) : null}
        </Box>
      </Box>
    </button>
  );
};

SelectableOptionCard.displayName = 'SelectableOptionCard';

export default SelectableOptionCard;
